import {atom} from "recoil";
import {LocationModelFE} from "../api/types/location";
import {SelectElementModelFE} from "../api/types/generic";

export const searchedLocationAtom = atom<string>({
    key: "searchedLocationAtom",
    default: ""
});

export const locationAtom = atom<LocationModelFE[]>({
    key: "locationAtom",
    default: []
});

export const locationsAtom = atom<SelectElementModelFE[]>({
    key: "locationsAtom",
    default: []
});
